export enum ConfigurationIdentifier {
	CargoEnabled = "CargoEnabled"
}
